import { Service } from '@piwikpro/platform';

@Service()
export class TooManyRequestsError extends Error {
  name = 'TooManyRequestsError';
}
